import { memo } from 'react';

import { CheckboxCircleFill } from '@moniebook-web/icons/system/checkbox-circle-fill';

import styles from './business-item.module.scss';
import type { BusinessItemProps } from './types';

function BusinessItemComponent({
    name,
    branchesCount = 0,
    isCurrent,
    id,
    onSelectCurrentBusiness,
}: Readonly<BusinessItemProps>) {
    return (
        <button
            className={styles.container}
            type='button'
            onClick={() => {
                if (!isCurrent) {
                    onSelectCurrentBusiness(id, name);
                }
            }}>
            <div className='flex w-full gap-16'>
                <div className={styles.avatar}>
                    <p>{name?.charAt(0)}</p>
                </div>
                <div className={styles.body}>
                    <p className={styles.title}>{name}</p>
                    <p className={styles.sbuTitle}>
                        {branchesCount}
                        {branchesCount > 1 ? 'Branches' : 'Branch'}
                    </p>
                </div>
            </div>

            {isCurrent && (
                <span
                    title='Current Business'
                    className='flex items-center justify-end'>
                    <CheckboxCircleFill className={styles.selected} />
                </span>
            )}
        </button>
    );
}

export const BusinessItem = memo(BusinessItemComponent);
